import {
  normalizeCommonFields,
  createActualBlockName,
  ActualNameCreator
} from '../common';

import { ActionSendStatsNormalizer, IActionSendStatsParams } from './client';

const createActionSendStatsActualNameBase = (labelTitle?: string): string => {
  return labelTitle || '';
};

export const createActionSendStatsActualName: ActualNameCreator<
  IActionSendStatsParams
> = ({ params }) => createActionSendStatsActualNameBase(params.label?.title);

export const normalizeActionSendStats: ActionSendStatsNormalizer = (
  raw,
  stores
) => {
  return {
    ...normalizeCommonFields(raw, stores),
    actualName: (t) =>
      createActualBlockName({
        paramsName: createActionSendStatsActualNameBase(
          raw.params.label_title || ''
        ),
        blockKind: raw.kind,
        blockName: raw.name,
        t,
        ...stores
      })
  };
};
